import {getAxiosInstance, rethrowErrorWithMessage} from '../helpers/axios-helper'
import dateHelper from '../helpers/date-helper'

const baseUrl = process.env.BACKEND_URL
console.log(' > baseUrl:', baseUrl)

function getGameById(gameId) {
  console.log('calling game by Id service')
  return getAxiosInstance().get(`${baseUrl}/games/${gameId}`)
    .then(teamsResult => {
      return teamsResult.data
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function startGame(gameId) {
  return getAxiosInstance().patch(`${baseUrl}/games/${gameId}/start`, {
    startTime: dateHelper.getFormattedStringDateNow(),
  })
    .then(game => {
      return game.data
    })
    .catch(err => {
      throw err
    })
}

function pauseGame(gameId) {
  return getAxiosInstance().patch(`${baseUrl}/games/${gameId}/pause`, {
    pausedTime: dateHelper.getFormattedStringDateNow(),
  })
        .then(game => {
          return game.data
        })
        .catch(err => {
          throw err
        })
}

function resumeGame(gameId) {
  return getAxiosInstance().patch(`${baseUrl}/games/${gameId}/resume`, {
    startTime: dateHelper.getFormattedStringDateNow(),
  })
    .then(game => {
      return game.data
    })
    .catch(err => {
      throw err
    })
}

function deCloneGame(gameId) {
  return getAxiosInstance().post(`${baseUrl}/games/${gameId}/declone`, {})
}

function generateNewPin(gameId) {
  return getAxiosInstance().post(`${baseUrl}/games/${gameId}/generateNewPin`, {})
}

function resetGame(gameId) {
  return getAxiosInstance().put(`${baseUrl}/games/${gameId}/reset`, {})
}

function archiveGame(gameId) {
  return getAxiosInstance().patch(`${baseUrl}/games/${gameId}/archive`, {})
}

function stopGame(gameId, gameLength) {
  return getAxiosInstance().patch(`${baseUrl}/games/${gameId}/stop`, {
    stopTime: dateHelper.getFormattedStringDateNow(),
    gameLength: gameLength,
  })
    .then(game => {
      return game.data
    })
    .catch(err => {
      throw err
    })
}

function getGames(includeArchives = false) {
  return getAxiosInstance().get(`${baseUrl}/games?includeArchives=${includeArchives}`)
    .then(gamesResult => {
      return gamesResult.data
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function createGame(game) {
  return getAxiosInstance().post(`${baseUrl}/games`, {
    game,
  })
    .then(gameCreated => {
      console.log('createGame called')
      return gameCreated.data
    })
    .catch(err => {
      rethrowErrorWithMessage(err)
    })
}

function createGameWithWizard(game) {
  return getAxiosInstance().post(`${baseUrl}/gamesWizard`, {
    game,
  })
    .then(gameCreated => {
      console.log('createGame with wizard called')
      return gameCreated.data
    })
    .catch(err => {
      rethrowErrorWithMessage(err)
    })
}

function createGamesEnMasse(objectId, selectedObjects, options, mode) {
  return getAxiosInstance().post(`${baseUrl}/gamesEnMasse`, {
    objectId, selectedObjects, options, mode
  })
    .then(gamesCreated => {
      console.log('createGamesEnMasse called with mode ' + mode)
      return gamesCreated.data
    })
    .catch(err => {
      rethrowErrorWithMessage(err)
    })
}

function createGamesWith1GameNPacks(idGame, selectedPacks) {
  return createGamesEnMasse(idGame, selectedPacks, null, '1gameNpacks')
}

function createGamesWith1PackNMaps(idPack, selectedMaps, options) {
  return createGamesEnMasse(idPack, selectedMaps, options, '1packNmaps')
}

function updateGame(game, gameId) {
  return getAxiosInstance().put(`${baseUrl}/games/${gameId}`, {
    game,
  })
    .then(gameCreated => {
      console.log('updateGame called')
      return gameCreated.data
    })
    .catch(err => {
      rethrowErrorWithMessage(err)
    })
}

function updateGameWithWizard(game, gameId) {
  return getAxiosInstance().put(`${baseUrl}/gamesWizard/${gameId}`, {
    game,
  })
    .then(gameCreated => {
      console.log('updateGame with wizard called')
      console.log(gameCreated.data)
      return gameCreated.data
    })
    .catch(err => {
      rethrowErrorWithMessage(err)
    })
}

function duplicateGameWithWizard(game, gameId, newGameName, duplicateTeams) {
  return getAxiosInstance().post(`${baseUrl}/duplicateGameWithWizard/${gameId}`, {
    game,
    newGameName,
    duplicateTeams
  })
    .then(gameDuplicated => {
      console.log('duplicateGameWithWizard called')
      console.log(gameDuplicated.data)
      return gameDuplicated.data
    })
    .catch(err => {
      rethrowErrorWithMessage(err)
    })
}

function duplicateGame(game, gameId) {
  return getAxiosInstance().post(`${baseUrl}/duplicateGame/${gameId}`, {
    game,
  })
    .then(gameDuplicated => {
      console.log('duplicateGame called')
      console.log(gameDuplicated.data)
      return gameDuplicated.data
    })
    .catch(err => {
      rethrowErrorWithMessage(err)
    })
}

function getLeaderBoard(gameId, isBase64ImageRequired) {
  return getAxiosInstance().get(`${baseUrl}/games/${gameId}/teamleaderboard?isBase64ImageRequired=${isBase64ImageRequired}`)
    .then(leaderboard => {
      return leaderboard.data
    })
}

function getGameCompletion(gameId) {
  return getAxiosInstance().get(`${baseUrl}/games/${gameId}/gameCompletion`)
        .then(gameCompletion => {
          return gameCompletion.data
        })
}

function getGameCompletionForTeam(gameId, teamId) {
  return getAxiosInstance().get(`${baseUrl}/games/${gameId}/gameCompletionForTeam/${teamId}`)
        .then(r => {
          return r.data
        })
}

function getGameMarkers(gameId) {
  return getAxiosInstance().get(`${baseUrl}/getGameMarkers/${gameId}`)
    .then(gamesResult => {
      console.log('getGameMarkers called')
      return gamesResult.data
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

export default {
  archiveGame,
  getGameById,
  createGame,
  createGamesEnMasse,
  createGamesWith1GameNPacks,
  createGamesWith1PackNMaps,
  getGames,
  updateGame,
  deCloneGame,
  duplicateGame,
  startGame,
  pauseGame,
  resumeGame,
  stopGame,
  resetGame,
  getLeaderBoard,
  getGameCompletion,
  getGameCompletionForTeam,
  getGameMarkers,
  createGameWithWizard,
  updateGameWithWizard,
  duplicateGameWithWizard,
  generateNewPin
}
